import React from 'react';
import { ChevronRightIcon, ClockIcon, MapPinIcon, SparklesIcon } from 'lucide-react';
import { followUps, registrations } from '../../data/loisirs';
export function MyActivities() {
  return <section aria-labelledby="my-activities-title" className="mt-14" data-id="element-1562" data-mp="16ut0pt3z7u51">
      <h2 id="my-activities-title" className="text-2xl font-extrabold tracking-tight text-ville-navy" data-id="element-1563" data-mp="16wx5ed9p8x6d">
        My activities
      </h2>
      <p className="mt-1 text-[15px] text-slate-600" data-id="element-1564" data-mp="x47vhmtsrrd5">Your registrations and your family’s.</p>

      <div className="mt-6 grid gap-5 lg:grid-cols-[minmax(0,1fr)_minmax(0,340px)] lg:gap-8" data-id="element-1565" data-mp="11vzp66892d7i">
        <ul className="space-y-3" data-id="element-1566" data-mp="o4babv6m9amu">
          {registrations.map(registration => <li key={registration.id} data-id="element-1567" data-mp="o28dar71qh8m">
              <button type="button" className="group flex w-full items-center gap-4 rounded-2xl border border-slate-200 bg-white px-5 py-4 text-left transition-colors duration-150 ease-ville hover:border-ville-indigo focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo" data-id="element-1568" data-mp="t2cwwq393s32">
                <span className="grid h-11 w-11 shrink-0 place-items-center rounded-full bg-slate-100 text-sm font-bold text-ville-navy" aria-hidden="true" data-id="element-1569" data-mp="3kc5qbg7i9sda">
                  {registration.initials}
                </span>
                <span className="min-w-0 flex-1" data-id="element-1570" data-mp="3tcbyqnock25l">
                  <span className="flex flex-wrap items-center gap-2" data-id="element-1571" data-mp="3pbs5hv6w9ioq">
                    <span className="font-bold text-ville-navy" data-id="element-1572" data-mp="3pcjom6jb1ny4">{registration.activity}</span>
                    <span className="rounded-full bg-ville-indigo-soft px-2.5 py-0.5 text-xs font-bold text-ville-indigo" data-id="element-1573" data-mp="31mph84hr8rl9">
                      {registration.participant} · registered
                    </span>
                  </span>
                  <span className="mt-1 flex flex-wrap items-center gap-x-4 gap-y-1 text-sm text-slate-500" data-id="element-1574" data-mp="35nsvimk5mfkd">
                    <span className="flex items-center gap-1.5" data-id="element-1575" data-mp="2hxyio4zu4r04">
                      <ClockIcon className="h-4 w-4" aria-hidden="true" data-id="element-1576" data-mp="2hw3vsl506ote" />
                      {registration.schedule}
                    </span>
                    <span className="flex items-center gap-1.5" data-id="element-1577" data-mp="gwqvg9uahbkn">
                      <MapPinIcon className="h-4 w-4" aria-hidden="true" data-id="element-1578" data-mp="gu4ly4nu8lzs" />
                      {registration.place}
                    </span>
                  </span>
                  <span className="mt-1 block text-sm font-semibold text-ville-navy" data-id="element-1579" data-mp="qmaebfi055fi">{registration.nextSession}</span>
                </span>
                <ChevronRightIcon className="h-5 w-5 shrink-0 text-slate-400 transition-colors duration-150 ease-ville group-hover:text-ville-indigo" aria-hidden="true" data-id="element-1580" data-mp="3u2imwuf6qy7p" />
              </button>
            </li>)}
        </ul>

        <aside aria-label="ATNA follow-ups" className="rounded-2xl border border-slate-200 bg-slate-50 p-5" data-id="element-1581" data-mp="7v14t688egnx">
          <p className="flex items-center gap-2 text-sm font-bold text-ville-indigo" data-id="element-1582" data-mp="cvf1xt8ao676">
            <SparklesIcon className="h-4 w-4" aria-hidden="true" data-id="element-1583" data-mp="1jazar1844mkx" />
            ATNA follow-ups
          </p>
          <ul className="mt-3 space-y-3" data-id="element-1584" data-mp="1o8r7c8jpcwvg">
            {followUps.map(item => <li key={item} className="rounded-xl bg-white px-4 py-3 text-sm leading-relaxed text-slate-600" data-id="element-1585" data-mp="38rl9zmahxjda">
                {item}
              </li>)}
          </ul>
        </aside>
      </div>
    </section>;
}